import { openDB } from "idb";

//0 - false, 1 - true
const questions = [
  {
    question: "Os papéis de género são criados pela sociedade?",
    image: "q1.svg",
    correct: 1,
    reason:
      "Os papéis de género correspondem às formas como a sociedade em geral espera que as pessoas atuem, falem, se vistam e comportem de acordo com o género que identificam nas outras pessoas.",
  },
  {
    question:
      "Designa-se de género as diferenças biológicas em pessoas, com base nos seus sistemas reprodutivos?",
    image: "q2.svg",
    correct: 0,
    reason:
      "As diferenças biológicas com base no sistema reprodutor são aquilo que designamos como sexo.",
  },
  {
    question:
      "Ser gay ou lésbica corresponde à identidade de género de alguém?",
    image: "q3.svg",
    correct: 0,
    reason:
      "Ser homossexual (gay, lésbica), heterossexual, bissexual, pansexual ou assexual, entre outras, correspondem a orientações sexuais.",
  },
  {
    question:
      "O género, ou o conceito de masculinidade e feminilidade, representa o mesmo em todas as culturas?",
    image: "q4.svg",
    correct: 0,
    reason:
      "O género é uma construção sócio-cultural, o que significa que os significados que lhe são dados variam de contexto sócio-cultural para contexto sócio-cultural.",
  },
  {
    question:
      "Em 2022, menos de 20% dos cargos políticos ministeriais em todo o mundo eram ocupados por mulheres?",
    image: "q5.svg",
    correct: 1,
    reason:
      "De acordo com o Global Gender Gap Report 2022, 16,1% dos cargos políticos ministeriais em todo o mundo eram ocupados por mulheres. Felizmente, desde 2006, pelo menos esse número quase duplicou, já que nesse ano representavam apenas 9,9%.",
  },
  {
    question:
      "Existe um Objetivo de Desenvolvimento Sustentável - ODS (desenvolvido pela Organização das Nações Unidas - ONU) focado na igualdade de género?",
    image: "q6.svg",
    correct: 1,
    reason:
      "Existem 17 ODS - Objetivos de Desenvolvimento Sustentável - da ONU, sendo que o ODS 5 chama-se “Igualdade de género” e tem como objetivo principal alcançar a igualdade de género e capacitar todas as mulheres e raparigas.",
  },
  {
    question: "O ciber-crime é punível em Portugal?",
    image: "q7.svg",
    correct: 1,
    reason:
      "Desde 2009 que em Portugal são puníveis os crimes promovidos via aparelhos eletrónicos, digitais e de recurso à internet (Lei n.º 109/2009, de 15 de setembro), o que inclui práticas como a transferência de ficheiros musicais ilegais, o roubo de identidade e crimes de ódio, a disseminação de vírus noutros aparelhos digitais, ou ainda o roubo de informação empresarial confidencial via internet.",
  },
  {
    question:
      "De acordo com o relatório de 2020 do Global Media Monitoring Project, no contexto europeu, num dia rotineiro de notícias, a presença global de mulheres na cobertura informativa era superior a 40%?",
    image: "q8.svg",
    correct: 0,
    reason:
      "De acordo com o relatório português do GMMP de 2020, no contexto europeu geral, a percentagem de mulheres na cobertura informativa, num dia rotineiro de notícias, é de 28%, ou seja, menos de 3 em cada 10 pessoas que protagonizam as notícias na Europa são mulheres.",
  },
  {
    question:
      "De acordo com o relatório de 2020 do Global Media Monitoring Project, num dia rotineiro de notícias, a presença global de mulheres na cobertura informativa é superior em Portugal em comparação com o contexto europeu global?",
    image: "q8.svg",
    correct: 1,
    reason:
      "De acordo com o relatório português do GMMP de 2020, num dia rotineiro de notícias, a presença global de mulheres na cobertura informativa portuguesa fixou-se nos 34%, uma percentagem ligeiramente acima dos 28% que caracterizam a presença global de mulheres no contexto europeu.",
  },
  {
    question:
      "Numa sociedade patriarcal a mulher/mãe tem uma posição dominante na família e na comunidade?",
    image: "q9.svg",
    correct: 0,
    reason:
      "Numa sociedade patriarcal os homens assumem liderança e dominância. Seja num contexto familiar como pais ou figuras paternas sobre mulheres e crianças, tal como num contexto social geral, numa sociedade patriarcal (ou seja, no patriarcado), os homens mantêm o poder e predominam em funções de liderança política, autoridade moral, privilégio social e controlo das propriedades. Uma sociedade onde a mulher/mãe tem uma posição dominante na família e na comunidade pode ser designada de matriarcado ou sociedade matriarcal.",
  },
  {
    question: "O género pode variar com o tempo?",
    image: "q10.svg",
    correct: 1,
    reason:
      "O género é uma construção fluída que não é necessariamente estanque, ou seja, que pode variar ao longo do tempo na expressão de género ou na identidade de género de uma pessoa, ou em ambas.",
  },
  {
    question:
      "O conceito de transgénero implica que uma pessoa realizou algum tipo de cirurgia genital de mudança de sexo?",
    image: "q11.svg",
    correct: 0,
    reason:
      "Transgénero é um termo utilizado para descrever pessoas cuja identidade de género não está em conformidade com os ideais típicos do que a sociedade dita ser apropriado para o seu sexo de nascimento. Ser transgénero não implica ter iniciado um processo médico-cirúrgico quer de cirurgia de redesignação sexual como de terapia hormonal.",
  },
  {
    question:
      "De acordo com o mais recente Mobile Gender Gap Report, ainda existem mais de 400 milhões de mulheres no mundo sem telemóvel?",
    image: "q12.svg",
    correct: 1,
    reason:
      "O Mobile Gender Gap Report de 2023 apresenta os dados da situação de 2022, demonstrando que em 2022, 440 milhões de mulheres não tinham acesso a telemóveis, ou seja, perto de 20% da população feminina mundial.",
  },
  {
    question:
      "Em 2022, mais de 50% das pessoas do mundo eram utilizadoras de plataformas de redes sociais/média sociais (social media)?",
    image: "q13.svg",
    correct: 1,
    reason:
      "De acordo com os dados da Statista, em 2022 existiam 4.59 mil milhões de pessoas no mundo a utilizar plataformas digitais de redes sociais/média sociais (social media), o que representa mais 50% dos 8 mil milhões de habitantes mundiais em 2022.",
  },
  {
    question:
      "Face aos dados de janeiro de 2023, o Facebook ainda é a plataforma de redes sociais/média sociais (social media) com mais utilizadores mensais ativos, no mundo inteiro?",
    image: "q14.svg",
    correct: 1,
    reason:
      "De acordo com os dados da Statista, em janeiro de 2023 o Facebook registou 2.958 mil milhões de utilizadores ativos, dando-lhe o estatuto de plataforma de redes sociais/média sociais (social media) com mais utilizadores mensais ativos. Nesse ranking, seguiram-se o YouTube, o WhatsApp e o Instagram.",
  },
  {
    question: "Em 2022, mais de 85% das pessoas no mundo esteve online?",
    image: "q3.svg",
    correct: 0,
    reason:
      "De acordo com os dados da International Telecommunication Union (ITU), uma agência da ONU, em 2022, estiveram online 66% das pessoas no planeta. A ITU considera “estar online” como estar ligado à internet pelo menos uma vez no período dos últimos três meses.",
  },
  {
    question:
      "Em 2021, entre as pessoas sem qualquer nível de escolaridade em Portugal, mais de 70% são mulheres?",
    image: "q16.svg",
    correct: 1,
    reason:
      "De acordo com os dados da CIG - Comissão para a Cidadania e a Igualdade de Género - no documento “Indicadores Chave 2022”, no ano de 2021, em cada 100 pessoas sem qualquer nível de escolaridade em Portugal, 73 eram mulheres (ou seja, 73%).",
  },
  {
    question:
      "No ano letivo de 2020/2021, em Portugal, o número de mulheres foi superior ao número de homens em quase todas as áreas do ensino superior, com exceção dos “Serviços”, das “Engenharias, indústrias transformadoras e construção” e das “Tecnologias da informação e comunicação (TIC)”?",
    image: "q17.svg",
    correct: 1,
    reason:
      "De acordo com os dados da CIG - Comissão para a Cidadania e a Igualdade de Género - no documento “Indicadores Chave 2022”, no ano letivo de 2020/2021, o número de mulheres foi superior ao número de homens em quase todas as áreas do ensino superior, com exceção dos “Serviços” (40,5% de mulheres), das “Engenharias, indústrias transformadoras e construção” (27,6% de mulheres) e das “Tecnologias da informação e comunicação (TIC)” (17,5% de mulheres). Dentro das restantes áreas onde o número de mulheres se superiorizou ao dos homens, houve duas áreas onde se destacavam proporcionalmente mais mulheres: “Saúde e proteção social” (78,5% de mulheres) e “Educação” (76,1%).",
  },
  {
    question:
      "No ano letivo de 2020/2021, em Portugal, o número de mulheres a concluir cursos universitários foi superior ao número de homens quer em licenciaturas, como mestrados e doutoramentos?",
    image: "q16.svg",
    correct: 1,
    reason:
      "De acordo com os dados da CIG - Comissão para a Cidadania e a Igualdade de Género - no documento “Indicadores Chave 2022”, no ano letivo de 2020/2021, as mulheres são maioritárias nas conclusões das licenciaturas (59,5% foram mulheres), dos mestrados (59,8%) e ainda nos doutoramentos (50,9%). A exceção foram os cursos técnicos superiores profissionais (onde a maioria das conclusões de curso foram de homens - 55,7%).",
  },
  {
    question:
      "Em 2021, em média, por cada 10 pessoas empregadas em Portugal na área das TIC - Tecnologias de Informação e Comunicação -, 3 ou mais eram mulheres?",
    image: "q18.svg",
    correct: 0,
    reason:
      "De acordo com os dados da CIG - Comissão para a Cidadania e a Igualdade de Género - no documento “Indicadores Chave 2022”, no ano de 2021, em média, por cada 10 pessoas empregadas em TIC em Portugal, cerca de 8 eram homens e apenas 2 mulheres (20,7%). Porém, no caso das mulheres, estes valores já se encontram acima da média da UE27 para esse ano (19,1%).",
  },
  {
    question:
      "Em 2021, entre a população em idade ativa (20 a 64 anos), a percentagem de mulheres inativas devido “à responsabilidade de cuidar” foi superior em Portugal face à realidade europeia geral?",
    image: "q9.svg",
    correct: 0,
    reason:
      "De acordo com os dados da CIG - Comissão para a Cidadania e a Igualdade de Género - no documento “Indicadores Chave 2022”, no ano de 2021, a percentagem de população inativa, entre os 20 e os 64 anos, devido “a responsabilidades de cuidar” foi maior na média de todos os países da Europa (30,2%) por comparação com a percentagem em Portugal (23,9%). Destaca-se que ambas demonstram uma maior tendência de inatividade de mulheres em idade ativa face aos homens (8,5% na Europa; 16,3% em Portugal).",
  },
  {
    question:
      "Nos últimos anos em Portugal, os casamentos “entre pessoas do mesmo sexo” tendem a ser superiores a 1000 casamentos por ano?",
    image: "q3.svg",
    correct: 0,
    reason:
      "Desde a legalização do casamento “entre pessoas do mesmo sexo” em Portugal que, de acordo com dados da PORDATA, o maior número anual foi 801, registado em 2022. Esses 801 também foram uma ligeira subida na proporcionalidade total, já que foram cerca de 2,17% da totalidade de casamentos em 2022 (36.952). Os dados da CIG - Comissão para a Cidadania e a Igualdade de Género - no documento “Indicadores Chave 2022”, indicam que, em 2021, o número de casamentos entre duas mulheres (262) foi muito semelhante ao número de casamentos entre dois homens (287), perfazendo um total de 549 casamentos entre pessoas do mesmo sexo em Portugal, em 2021, o que representou 1,89% do total de casamentos registados em Portugal nesse ano (29.057).",
  },
  {
    question:
      "Em 2022, entre os 27 países da União Europeia, Portugal era o que tinha menor percentagem de homens e de mulheres (entre os 25 e os 64 anos) sem o ensino secundário?",
    image: "q16.svg",
    correct: 1,
    reason:
      "De acordo com dados da PORDATA, em 2022, Portugal foi o país da UE27 com maior percentagem da população entre os 25 e os 64 anos sem o ensino secundário (39,7%), seguido de Itália, Espanha, Malta e Grécia. Este não é um dado novo, já que Portugal ocupa este primeiro posto desde 2009, ano em que substituiu Malta como líder da maior percentagem de cidadãos e cidadãs sem o ensino secundário. Em relação aos 39,7% da população portuguesa (entre os 25 e os 64 anos) em 2022, é interessante apontar que, entre os homens, 44,2% não têm ensino secundário, enquanto que a percentagem é relativamente inferior entre as mulheres (35,5%).",
  },
  {
    question:
      "A diferença salarial entre homens e mulheres é inferior a 200 euros, em Portugal, face aos dados de 2021?",
    image: "q9.svg",
    correct: 0,
    reason:
      "Não é um número necessariamente novo, em Portugal as mulheres continuam a receber menos que os homens. De acordo com dados da PORDATA, em 2021, os homens, em média, receberam mais 223 euros do que as mulheres.",
  },
  {
    question: "Em Portugal, existem menos telemóveis do que pessoas?",
    image: "q1.svg",
    correct: 0,
    reason:
      "Já há mais de uma década que o número de telemóveis, entre particulares e de empresas, é superior aos 10 milhões (número de habitantes em Portugal), de acordo com os dados da PORDATA. Aliás, em 2021, existiam em Portugal mais de 14 milhões de telemóveis.",
  },
  {
    question:
      "Há menos de 200 milhões de utilizadores/as mundiais de aplicações móveis de dating (encontro/namoro)?",
    image: "q3.svg",
    correct: 0,
    reason:
      "As aplicações móveis de dating (encontro/namoro) estão num grande crescimento. De acordo com dados da Statista, em 2022, existiam mais de 366 milhões de utilizadores/as de aplicações de dating, o que equivale a mais de 4% da população mundial.",
  },
  {
    question:
      "A proporção da população portuguesa acima dos 16 anos que utiliza a internet passou a ser superior a 50% do total apenas desde 2019?",
    image: "q13.svg",
    correct: 0,
    reason:
      "De acordo com dados da PORDATA, desde 2002 a 2022, a proporção de pessoas com 16 ou mais anos que utilizam internet em % do total de indivíduos, cresce todos os anos. Em 2002 essa percentagem era de 19,4%, enquanto que em 2022 já eram 84,5%. A passagem acima da barreira de 50% da população acima dos 16 anos a utilizar a internet deu-se em 2010, quando, segundo estes dados, 51,1% da população portuguesa utilizava a internet.",
  },
  {
    question:
      "Em Portugal pode pedir-se o registo de mudança da menção do sexo e do nome próprio a partir dos 16 anos?",
    image: "q2.svg",
    correct: 1,
    reason:
      "Em Portugal, os cidadãos nacionais podem solicitar o registo de mudança da menção do sexo e do nome próprio a partir dos 16 anos (desde 2018), sendo que pessoas com 16 ou 17 anos necessitam de representantes legais, em conjunto com um relatório médico apropriado e a expressão de consentimento livre e informado na presença de um conservador.",
  },
  {
    question:
      "Nos dez primeiros anos de possibilidade legal portuguesa de mudança da menção do sexo e do nome próprio, o número médio de pedidos por ano ultrapassa os 1000 por ano?",
    image: "q4.svg",
    correct: 0,
    reason:
      "Em Portugal, desde 2011 que os cidadãos nacionais podem solicitar o registo de mudança da menção do sexo e do nome próprio. De acordo com os dados da CIG - Comissão para a Cidadania e a Igualdade de Género - no documento “Igualdade de Género em Portugal: Boletim Estatístico 2022”, foi 2001 o ano com maior número total de pedidos de mudança da menção do sexo e do nome próprio, registando-se 400 pedidos. Nos anos anteriores, o total de pedidos por ano nunca ultrapassou os 250.",
  },
  {
    question:
      "Em 2021, os agregados domésticos monoparentais (apenas uma mãe ou pai e filhos) em Portugal, eram 30% das vezes compostos por homens e seus filhos?",
    image: "q19.svg",
    correct: 0,
    reason:
      "De acordo com os dados da CIG - Comissão para a Cidadania e a Igualdade de Género - no documento “Igualdade de Género em Portugal: Boletim Estatístico 2022”, em 2021, apenas 18,1% dos agregados monoparentais eram compostos por um pai/homem adulto, ou seja, 81,9% eram compostos por uma mãe/mulher adulta e seus filhos. Na verdade, esses valores representam a maior aproximação entre uma paridade de género no volume total de agregados domésticos monoparentais em Portugal, já que, por exemplo, em 2018 os agregados monoparentais masculinos eram apenas 12,9%; e os agregados monoparentais de mulheres eram 87,1%.",
  },
];

/* The above code is creating an object store in a database using IndexedDB. It checks if the object
store named "question" already exists in the database. If it doesn't exist, it creates the object
store with a key path of "id" and auto-incrementing IDs. It also creates indexes for the attributes
"question", "image", "correct", and "reason". Finally, it adds questions to the object store using
the `questions` array. If there is an error while adding a question, it logs an error message. */
const connection = openDB("db", "1", {
  upgrade(db) {
    //perguntas
    if (!db.objectStoreNames.contains("question")) {
      const objectStore = db.createObjectStore("question", {
        keyPath: "id",
        autoIncrement: true,
      });

      //atributos
      objectStore.createIndex("question", "question", { unique: true });
      objectStore.createIndex("image", "image", { unique: false });
      objectStore.createIndex("correct", "correct", { unique: false });
      objectStore.createIndex("reason", "reason", { unique: false });

      questions.forEach((question) => {
        objectStore.add(question).catch((error) => {
          //#1 - Erro ao adicionar questão na BD (code ID: 1)
          console.error("Ocorreu um erro na execução da app! (ERROR: #1)");
        });
      });
    }
  },
});

/**
 * The function `getAllKeys` retrieves all keys from the "question" collection.
 * @returns all the keys from the "question" collection in the database.
 */
export async function getAllKeys() {
  return (await connection).getAll("question");
}

/**
 * The function `getQuestionById` retrieves a question object from an indexedDB object store based on
 * the provided id.
 * @param id - The `id` parameter is the unique identifier of the question that you want to retrieve
 * from the database.
 * @returns a promise that resolves to the result of the `get` operation on the "question" object store
 * in the indexedDB database.
 */
export async function getQuestionById(id) {
  return (await connection)
    .transaction("question", "readonly")
    .objectStore("question")
    .get(Number(id));
}
